import { Tabs } from "antd";
import WithAuthenticated from "../../components/WithAuthenticated";
import RichMenuSettingPanel from "../../components/RichMenuSettingPanel";
import RichMenuSettingPanel2 from "../../components/RichMenuSettingPanel2";
import ContentContainer from "../../components/ContentContainer";
import Breadcrumb from "../../components/Breadcrumb";

const { TabPane } = Tabs;

const Container = () => {
  return (
    <>
      <Breadcrumb
        title="Rich Menu"
        items={[{ title: "Rich Menu", location: "" }]}
      />
      <ContentContainer>
        <Tabs defaultActiveKey="default">
          <TabPane tab="PATConnex" key="1">
            <ContentContainer>
              <RichMenuSettingPanel
                key="default"
                header="Default Rich menu"
                event="default"
              />
            </ContentContainer>
            <ContentContainer style={{ marginTop: 24 }}>
              <RichMenuSettingPanel
                key="after_register"
                header="Rich menu after bind account"
                event="after_register"
              />
            </ContentContainer>
          </TabPane>
          <TabPane tab="ทันข่าว" key="2">
            <ContentContainer>
              <RichMenuSettingPanel2
                key="default"
                header="Default Rich menu"
                event="default"
              />
            </ContentContainer>
            <ContentContainer style={{ marginTop: 24 }}>
              <RichMenuSettingPanel2
                key="after_register"
                header="Rich menu after bind account"
                event="after_register"
              />
            </ContentContainer>
          </TabPane>
        </Tabs>
      </ContentContainer>
    </>
  );
};

export default WithAuthenticated(Container);
